<template>
  <div
    v-if="accordions"
    class="accordion__wrapper"
    :class="[
      $blockClass(blockClass, 'wrapper'),
    ]"
  >
    <div
      v-for="(accordion, index) of accordions"
      :key="index"
      class="accordion__item"
      :class="[
        $blockClass(blockClass, 'accordion'),
      ]"
    >
      <button
        type="button"
        class="accordion__trigger"
        :class="[
          $blockClass(blockClass, 'trigger'),
          { [$class('active')]: isActive(index) }
        ]"
        :aria-expanded="isActive(index)"
        @click="toggleAccordion(index)"
      >
        <span
          class="accordion__trigger-label"
          :class="[
            $blockClass(blockClass, 'trigger-label'),
            { [$class('active')]: isActive(index) }
          ]"
          v-text="accordion.title"
        />

        <icon-plus />
      </button>

      <transition-height>
        <div
          v-show="isActive(index)"
          class="rte accordion__body"
          :class="[
            $blockClass(blockClass, 'body'),
          ]"
        >
          <div v-if="showDropdown(index)">
            <div v-html="accordionBody(index, 0)" />

            <shipping-dropdown
              v-if="dropdownData.length"
              :dropdown-data="dropdownData"
            />

            <div v-html="accordionBody(index, 1)" />
          </div>

          <div
            v-else
            v-html="accordion.body"
          />
        </div>
      </transition-height>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Accordion Component (accordion-component)
 * -----------------------------------------------------------------------------
 * Global accordion component
 *
 * @param {String} blockClass - Block level class to apply to all elements.
 * @param {Array} accordionData - Array of objects containing title and body.
 * @param {Array} dropdownData - Array of objects to be shown in dropdown.
 */

import IconPlus from '~icons/directional-navigation/plus.svg'
import ShippingDropdown from '~async/shipping-dropdown/shipping-dropdown'
import TransitionHeight from '~async/transition-height/transition-height'

export default {
  name: 'AccordionComponent',

  components: {
    IconPlus,
    ShippingDropdown,
    TransitionHeight,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    accordionData: {
      type: Array,
      default: () => [],
    },
    dropdownData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      accordions: [],
    }
  },

  mounted() {
    this.accordions = this.accordionData.map((accordion) => {
      return {
        active: false,
        ...accordion,
      }
    })
  },

  methods: {

    /**
     * Check if an accordion is active using its index.
     * @param {Number} index - Index of a specific accordion.
     * @returns {Boolean}
     */
    isActive(index) {
      return this.accordions[index].active
    },

    /**
     * Toggles the clicked accordion
     * @param {String} accordionIndex - Index of the clicked accordion
     */
    toggleAccordion(accordionIndex) {
      if (this.isActive(accordionIndex)) {
        this.accordions[accordionIndex].active = false
        return
      }

      this.accordions.forEach((panel, index) => {
        panel.active = accordionIndex === index
      })
    },

    /**
     * Determines if accordion content contains dropdown based on comment
     * - Comment format to show dropdown: ### dropdown ###
     * @param {String} accordionIndex - Index of the current accordion
     * @returns {Boolean}
     */
    showDropdown(accordionIndex) {
      const body = this.accordions[accordionIndex].body
      return (/###.*###/).test(body)
    },

    /**
     * Formats accordion body content if dropdown comment is included
     * @param {String} accordionIndex - Index of the current accordion
     * @returns {Array}
     */
    accordionBody(accordionIndex, bodyIndex) {
      const body = this.accordions[accordionIndex].body

      const formattedBody = body.split(/###.*###/)
      return formattedBody[bodyIndex]
    },
  },
}
</script>
